import {httpGet, httpGetBlob, httpPost} from "./http";

const invoiceUrl = window.env.BACKEND_API_URL + '/invoices';
const legacyInvoiceUrl = window.env.BACKEND_API_URL + '/legacy_invoices';

const getInvoices = async ({accountID, page, perPage}, signal) => {
    const url = invoiceUrl + `?account_id=${accountID}&page=${page}&per_page=${perPage}`;
    return httpGet(url, signal);
};

const createInvoice = async ({ended_at, account_id}, signal) => {
    const url = invoiceUrl;
    const body = {ended_at, account_id};
    return httpPost(url, body, signal);
};

const createInvoiceAllAccounts = async ({ended_at}, signal) => {
    const invoiceAllAccountsURL = invoiceUrl + '/all_accounts';
    const body = {ended_at};
    return httpPost(invoiceAllAccountsURL, body, signal);
};

const getPreviousInvoice = async ({account_id}, signal) => {
    const url = `${invoiceUrl}/previous?account_id=${account_id}`;
    return httpGet(url, signal);
};

const getInvoicePDF = async (number, signal) => {
    const url = `${invoiceUrl}/pdf?number=${number}`;

    return httpGetBlob(url, signal);
}

const getLegacyInvoices = ({accountID, page, perPage}, signal) => {
    const url = legacyInvoiceUrl + `?account_id=${accountID}&page=${page}&per_page=${perPage}`;
    return httpGet(url, signal);
};

const getLegacyInvoicePDF = async (number, signal) => {
    const url = `${legacyInvoiceUrl}/pdf?number=${number}`;

    return httpGetBlob(url, signal);
}

const sendMassNotifications = async (signal) => {
    const url = `${invoiceUrl}/mass_notifications/send`;
    return httpPost(url, '', signal);
};

export {
    getInvoices,
    getPreviousInvoice,
    createInvoice,
    getInvoicePDF,
    createInvoiceAllAccounts,
    getLegacyInvoices,
    getLegacyInvoicePDF,
    sendMassNotifications,
};
